import React, { useState } from "react"
import Header from "../../../components/Header"
import NavTabs from "../../../components/NavTabs"
import routes from "../../../routes/ecommerce.routes"
import { IBranchEcommerce, IConfig } from "./interface"
import { ButtonContainerForLargeDevices, ButtonContainerForSmallDevices, FlexBox, ContainerInputColor, ContainerTextArea, ContainerTitle, FieldLabel, LengthTextArea, Textarea, TextDescription, ContainerButton, Box } from "./style"
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import ErrorMessage from "../../../components/ErrorMessage";
import { useSelector } from "react-redux"
import api from "../../../service/api"
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { openModal } from "../../../helpers/modalFunctions"
import { useQuery } from "react-query"
import { putBlock } from "../../../service/putBlock"
import { toast, ToastContainer } from "react-toastify"

const Config = ({}: IConfig) => {
    const [branchData, setBranchData] = useState<IBranchEcommerce>({
        primaryColor: "",
        secundaryColor: "",
        businessInstagram: "",
        businessTwitter: "",
        businessFacebook: "",
        businessWebSite: "",
        storyDescription: "",
    })

    const [errorOnReturnApi, setErrorOnReturnApi] = useState<boolean>(false)
    const login = useSelector((state: {login: any}) => state.login);

    useQuery("getBranchsInfos", () => {
        getBranchInfos()
    })

    const getBranchInfos = async (): Promise<void> => {
        const {data} = await api.get("/adm/ownerbranch/list", {
            params: {
                branchId: login.user.branchsId
            }
        });

        setBranchData(data.Branch[0].Branch);
    }

    const formValidationWithYup = Yup.object().shape({
        primaryColor: Yup.string().nullable(),
        secundaryColor: Yup.string().nullable(),
        businessInstagram: Yup.string().nullable(),
        businessTwitter: Yup.string().nullable(),
        businessFacebook: Yup.string().nullable(),
        businessWebSite: Yup.string().nullable(),
        storyDescription: Yup.string().nullable(),
    })

    const submitForm = async (values: IBranchEcommerce): Promise<void> => {
        const { isError } = await putBlock("/configuration/update", 
            {
                storyDescription: values.storyDescription,
                primaryColor: values.primaryColor,
                secundaryColor: values.secundaryColor,
                businessInstagram: values.businessInstagram,
                businessFacebook: values.businessFacebook,
                businessWebSite: values.businessWebSite,
                taxpayerIdBranch: login.user.branchs.taxpayerIdBranch,
            }
        );

        if(isError) {
            toast.error("Houve um problema ao fazer as alterações, entre em contato com o suporte.", {
                theme: "colored"
            })
            setErrorOnReturnApi(true);
        }

        {
            setErrorOnReturnApi(false);
            toast.success("Alterações salvas!")
            getBranchInfos()
        }
    }

    return (
        <>
            <Header title="Configurações" subTitle="Aqui você pode configurar seu ecommerce ou landing page." subTitleWidth={200}/>
            <NavTabs tabs={routes}/>
            <ToastContainer autoClose={2000}/>
            <Formik
                initialValues={{
                    primaryColor: "",
                    secundaryColor: "",
                    businessInstagram: "",
                    businessTwitter: "",
                    businessFacebook: "",
                    businessWebSite: "",
                    storyDescription: "",
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    submitForm(values)
                }}
            >
                {({initialValues, values}) => {
                    initialValues.businessFacebook = branchData.businessFacebook;
                    initialValues.businessInstagram = branchData.businessInstagram;
                    initialValues.businessTwitter = branchData.businessTwitter;
                    initialValues.businessWebSite = branchData.businessWebSite;
                    initialValues.primaryColor = branchData.primaryColor;
                    initialValues.secundaryColor = branchData.secundaryColor;
                    initialValues.storyDescription = branchData.storyDescription

                    return (
                        <Form>
                            <Box className="row">
                                <Box className="col-12 col-lg-4">
                                    <ContainerTitle>Ecommerce</ContainerTitle>
                                    <FlexBox>
                                        <ContainerInputColor>
                                            <FieldLabel htmlFor="primaryColor">Cor primária</FieldLabel>
                                            <Field 
                                                id="primaryColor" 
                                                name="primaryColor" 
                                                className="inputCustom color" 
                                                type="color" 
                                                as={Input}
                                            />
                                        </ContainerInputColor>
                                        <ContainerInputColor>
                                            <FieldLabel htmlFor="secundaryColor">Cor secundária</FieldLabel>
                                            <Field 
                                                id="secundaryColor" 
                                                name="secundaryColor" 
                                                className="inputCustom color" 
                                                type="color" 
                                                as={Input}
                                            />
                                        </ContainerInputColor>
                                    </FlexBox>
                                    <FieldLabel htmlFor="businessInstagram">Link do instagram</FieldLabel>
                                    <Field 
                                        id="businessInstagram" 
                                        name="businessInstagram" 
                                        className="inputCustom" 
                                        placeholder="Instagram" 
                                        as={Input}
                                    />
                                    <FieldLabel htmlFor="businessFacebook">Link do facebook</FieldLabel>
                                    <Field 
                                        id="businessFacebook" 
                                        name="businessFacebook" 
                                        className="inputCustom" 
                                        placeholder="Facebook" 
                                        as={Input}
                                    />

                                    <FieldLabel htmlFor="businessWebSite">Nome da loja virtual</FieldLabel>
                                    <Field 
                                        id="businessWebSite" 
                                        name="businessWebSite" 
                                        className="inputCustom" 
                                        placeholder="Nome a ser exibido na loja virtual" 
                                        as={Input}
                                    />

                                    <FieldLabel htmlFor="storyDescription">Descrição da loja</FieldLabel>
                                    <ContainerTextArea>
                                        {
                                            values.storyDescription
                                            ? <>
                                                Número de caracteres restantes:
                                                <LengthTextArea> {123 - values.storyDescription.length}</LengthTextArea>
                                            </>
                                            : null
                                        }
                                    </ContainerTextArea>
                                    <Field 
                                        id="storyDescription" 
                                        maxLength={123} 
                                        rows={3} 
                                        cols={42} 
                                        name="storyDescription" 
                                        className="inputCustom" 
                                        placeholder="Descrição da loja" 
                                        as={Textarea}
                                    />
                                    <ButtonContainerForLargeDevices>
                                            {
                                                errorOnReturnApi ?
                                                    <ErrorMessage>
                                                        Falha ao atualizar informações
                                                    </ErrorMessage> : null
                                            }
                                            <Button type="submit">Salvar Alterações</Button>
                                    </ButtonContainerForLargeDevices>
                                </Box>
                                <Box className="col-12 col-lg-4">
                                    <ContainerTitle>Landing page</ContainerTitle>
                                    
                                    <TextDescription>
                                        Edite banners, produtos, textos da sua landing page clicando no botão a baixo.
                                    </TextDescription>
                                    <ContainerButton>
                                        <Button 
                                            onClick={() => window.open()}
                                            type="button" 
                                        >
                                            Ir para editor
                                        </Button>
                                    </ContainerButton>
                                </Box>
                            </Box>
                            <Box className="row">
                                <Box className="col-12 col-lg-4">
                                    <ButtonContainerForSmallDevices>
                                        {
                                            errorOnReturnApi &&
                                                <ErrorMessage>
                                                    Falha ao atualizar informações
                                                </ErrorMessage>
                                        }
                                        <Button type="submit" >Salvar Alterações</Button>
                                    </ButtonContainerForSmallDevices>
                                </Box>
                            </Box>
                            
                        </Form>
                    )
                }
                }
            </Formik>
        </>
    )
}

export default Config